import { deleteReportEventsItem, getAllReportEventsItems } from 'src/api/report-events/offlineReportEventsApi';
import useApi from 'src/api/useApi';

const useSyncOfflineReportEvents = () => {
    const { postApiData } = useApi();

    const syncReportEvents = async () => {
        const reportEventsItems = await getAllReportEventsItems();
        reportEventsItems.sort((a, b) => a.lastUpdated - b.lastUpdated);

        try {
            for (let i = 0; i < reportEventsItems.length; i++) {
                const item = reportEventsItems[i];
                const request = item.deleteEventRequest ?? item.updateEventRequest ?? item.createEventRequest;

                if (request) {
                    await postApiData({ fullUrl: request.url, data: request.body, skipRefreshCacheEndpoints: i < reportEventsItems.length - 1 });
                    await deleteReportEventsItem(item.eventId);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    return {
        syncReportEvents,
    };
};

export default useSyncOfflineReportEvents;
